/* eslint-disable react/require-default-props */
import { Route, RouteProps, Redirect } from "react-router-dom";
import { useAuth } from "../hooks/auth";

// interface RouteProps extends ReactDOMRouterProps {
//   isPrivate?: boolean
//   component: React.ComponentType
// }
interface Props extends RouteProps {
  isPrivate: boolean;
  // signed: boolean
  component: React.ComponentType;
}

export default function PrivateRoutes({
  isPrivate,
  // signed,
  component: Component,
  ...rest
}: Props) {
  const { user } = useAuth();

  // if (loading) {
  //   return <h1>Carregando</h1>
  // }

  // if (isPrivate) {
  //   return <Redirect to="/" />
  // }

  // return <Route {...rest} />

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? "/" : "/pagina-inicial",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}
